export const REPORT_STATUS = {
  COMPLETED: "completed",
  PENDING: "pending",
};

const isFilled = (value) => value !== undefined && value !== null && String(value).trim() !== "";

export const getResultStatus = (result, isTextType = false) => {
  if (!result) return REPORT_STATUS.PENDING;

  const hasValue = isFilled(result.value);
  const hasRequiredFields = isTextType
    ? hasValue
    : hasValue && isFilled(result.testUnit) && isFilled(result.normalValue);

  if (result.status === REPORT_STATUS.COMPLETED || hasRequiredFields) {
    return REPORT_STATUS.COMPLETED;
  }

  return REPORT_STATUS.PENDING;
};

export const getReportStatus = (report) => {
  if (!report) return REPORT_STATUS.PENDING;
  if (report.status === REPORT_STATUS.COMPLETED) return REPORT_STATUS.COMPLETED;

  const results = Array.isArray(report.results) ? report.results : [];
  if (results.length > 0 && results.every((result) => result.status === REPORT_STATUS.COMPLETED)) {
    return REPORT_STATUS.COMPLETED;
  }

  return REPORT_STATUS.PENDING;
};

export const getOrderStatus = (order) => getReportStatus(order?.report);

export const getStatusBadgeClass = (status) => (
  status === REPORT_STATUS.COMPLETED
    ? "bg-green-100 text-green-700"
    : "bg-yellow-100 text-yellow-700"
);
